import { Typography } from "@mui/material";
import Modal from "../ui/Modal";

const DeleteCourseModal = (props) => {
  return (
    <Modal {...props} title="Delete Course" actionText="Delete">
      <Typography>
        Do you want to delete course '{props.course?.name}'? <br /> All materail
        will be deleted.
      </Typography>
    </Modal>
  );
};

export default DeleteCourseModal;
